/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:8b483a33-e1a2-4cdb-ade6-0d2524f7ae8a",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_pxKWNuAiZ",
    "aws_user_pools_web_client_id": "32pnq1pdp2f4bedpuabb1c7tag",
    "oauth": {
        "domain": "archicam-auth-dev.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/",
        "redirectSignOut": "http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "archicam-clients-instant-store-2020173714-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://54ne42qlnzehrjax5iyzdrj7au.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://ewdkjxw2l3.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        }
    ],
    "aws_content_delivery_bucket": "archicam-20201122163935-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://dqcz7vxthban4.cloudfront.net"
};


export default awsmobile;
